import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Profile } from '../../../pages/about-us/management-team';
import { MediaComponent, StrapiImageComponent } from '../MediaComponent/MediaComponent';
import styles from './profile.module.scss';

const ProfileComponent = (props: Profile) => (
    <div className={styles.container}>
        {props.image ? (
            <div className={styles.profilePicture}>
                <MediaComponent
                    src={props.image.src}
                    alt={props.image.alt}
                    maxHeight={props.image.maxHeight}
                    maxWidth={props.image.maxHeight}
                />
            </div>
        ) : (
            <LazyLoadImage src="/images/grey-background.svg" alt="" height="" width="" />
        )}
        <ul className={styles.list}>
            <li className={styles.name}>{props.name}</li>
            <li>{props.role}</li>
            {props.linkedInProfile ? (
                <li className={styles.pt20}>
                    <a href={props.linkedInProfile}>➔ LinkedIn</a>
                </li>
            ) : null}
        </ul>
    </div>
);

export default ProfileComponent;
